import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=c67a46d0&scoped=true&"
import script from "./DocumentItem.vue?vue&type=script&lang=js&"
export * from "./DocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentItem.vue?vue&type=style&index=0&id=c67a46d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67a46d0",
  null
  
)

export default component.exports